
export default function Services() {
  const products = [
    {
      name: 'Velvet Matte Lipstick',
      brand: 'Charlotte Tilbury',
      price: '$38',
      originalPrice: '$48',
      rating: 4.9,
      reviews: 312,
      badge: 'Best Seller',
      image: 'https://public.readdy.ai/ai/img_res/f8db43277476187be7c2abe73c3ff6d9.jpg'
    },
    {
      name: 'Glow Serum Foundation',
      brand: 'NARS Cosmetics',
      price: '$52',
      originalPrice: null,
      rating: 4.8,
      reviews: 204,
      badge: 'New Arrival',
      image: 'https://readdy.ai/api/search-image?query=luxury%20foundation%20bottle%20glass%20packaging%20with%20pump%20dispenser%20warm%20beige%20tone%20sitting%20on%20white%20surface%20soft%20pink%20background%20premium%20skincare%20cosmetics%20product%20photography%20elegant%20minimal%20clean%20studio%20lighting&width=400&height=420&seq=prod-foundation-001&orientation=portrait'
    },
    {
      name: 'Smoky Eye Palette',
      brand: 'Urban Decay',
      price: '$45',
      originalPrice: '$60',
      rating: 4.7,
      reviews: 189,
      badge: 'Sale',
      image: 'https://readdy.ai/api/search-image?query=open%20eyeshadow%20palette%20with%20rich%20dark%20smoky%20shades%20black%20brown%20gold%20shimmer%20matte%20colors%20luxury%20cosmetics%20product%20photography%20on%20white%20marble%20surface%20elegant%20packaging%20beauty%20store%20display%20warm%20lighting&width=400&height=420&seq=prod-palette-001&orientation=portrait'
    },
    {
      name: 'Lash Amplify Mascara',
      brand: 'Lancôme',
      price: '$29',
      originalPrice: null,
      rating: 4.9,
      reviews: 427,
      badge: 'Best Seller',
      image: 'https://readdy.ai/api/search-image?query=luxury%20mascara%20tube%20black%20elegant%20packaging%20standing%20on%20white%20surface%20with%20soft%20pink%20background%20premium%20cosmetics%20product%20photography%20clean%20minimal%20studio%20lighting%20beauty%20brand%20feminine%20aesthetic&width=400&height=420&seq=prod-mascara-001&orientation=portrait'
    },
    {
      name: 'Rose Glow Blush',
      brand: 'Fenty Beauty',
      price: '$34',
      originalPrice: null,
      rating: 4.8,
      reviews: 156,
      badge: 'New Arrival',
      image: 'https://readdy.ai/api/search-image?query=luxury%20blush%20compact%20powder%20rose%20pink%20shade%20open%20case%20with%20mirror%20elegant%20packaging%20on%20white%20marble%20surface%20premium%20cosmetics%20product%20photography%20soft%20feminine%20background%20warm%20lighting%20beauty%20store&width=400&height=420&seq=prod-blush-001&orientation=portrait'
    },
    {
      name: 'Hydra Plump Lip Gloss',
      brand: 'Dior Beauty',
      price: '$42',
      originalPrice: '$50',
      rating: 4.6,
      reviews: 98,
      badge: 'Sale',
      image: 'https://readdy.ai/api/search-image?query=luxury%20lip%20gloss%20tube%20sheer%20pink%20shade%20elegant%20gold%20packaging%20standing%20on%20white%20surface%20soft%20pink%20background%20premium%20cosmetics%20product%20photography%20clean%20minimal%20studio%20lighting%20beauty%20brand%20feminine%20aesthetic&width=400&height=420&seq=prod-gloss-001&orientation=portrait'
    },
  ];

  const badgeColors: Record<string, string> = {
    'Best Seller': 'bg-rose-500 text-white',
    'New Arrival': 'bg-emerald-500 text-white',
    'Sale': 'bg-amber-500 text-white',
  };

  return (
    <section id="services" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-end justify-between mb-16">
          <div>
            <p className="text-rose-400 text-xs tracking-widest uppercase mb-4">OUR PRODUCTS</p>
            <h2 className="font-serif text-[#2a2a2a] leading-tight" style={{ fontSize: '56px' }}>
              Makeup Must-Haves<br />
              <span className="text-rose-400">Loved by Thousands</span>
            </h2>
          </div>
          <button className="border-2 border-rose-400 text-rose-500 px-8 py-3 rounded-full text-sm font-medium hover:bg-rose-500 hover:text-white transition-all whitespace-nowrap cursor-pointer">
            View All Products
          </button>
        </div>

        <div className="grid grid-cols-3 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-[#FDF8F6] rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="relative w-full h-[280px] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className={`absolute top-4 left-4 text-xs font-semibold px-3 py-1 rounded-full ${badgeColors[product.badge]}`}>
                  {product.badge}
                </span>
                <button className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/80 rounded-full hover:bg-rose-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-heart-line text-base text-gray-600 group-hover:text-rose-500"></i>
                </button>
              </div>

              <div className="p-5">
                <p className="text-rose-400 text-xs font-semibold tracking-wide uppercase mb-1">{product.brand}</p>
                <h3 className="text-[#2a2a2a] font-semibold text-base mb-2">{product.name}</h3>

                <div className="flex items-center gap-2 mb-4">
                  <div className="flex items-center gap-0.5">
                    {[1,2,3,4,5].map(i => (
                      <i key={i} className={`ri-star-fill text-xs ${i <= Math.round(product.rating) ? 'text-amber-400' : 'text-gray-200'}`}></i>
                    ))}
                  </div>
                  <span className="text-gray-500 text-xs">({product.reviews})</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-[#2a2a2a] font-bold text-lg">{product.price}</span>
                    {product.originalPrice && (
                      <span className="text-gray-400 text-sm line-through">{product.originalPrice}</span>
                    )}
                  </div>
                  <button className="bg-rose-500 text-white px-5 py-2 rounded-full text-xs font-semibold hover:bg-rose-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-1.5">
                    <i className="ri-shopping-bag-line text-sm"></i>
                    Add to Bag
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
